import { render, staticRenderFns } from "./FormInputTextarea.vue?vue&type=template&id=a53ff3e2&"
import script from "./FormInputTextarea.vue?vue&type=script&lang=js&"
export * from "./FormInputTextarea.vue?vue&type=script&lang=js&"
import style0 from "./FormInputTextarea.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports